import React, { useState, useEffect } from "react";
import Modal from "../../../../components/ui/Modal";
import Button from "../../../../components/ui/Button";
import Input from "../../../../components/ui/Input";

const ConnectPlatformModal = ({ isOpen, onClose, platform, onConnect }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Reset form when modal opens/closes or platform changes
  useEffect(() => {
    if (isOpen) {
      setUsername("");
      setPassword("");
      setIsLoading(false);
    }
  }, [isOpen, platform]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!username || !password) return;

    setIsLoading(true);
    
    // Simulate API call
    setTimeout(() => {
      onConnect(platform?.id, username);
      setIsLoading(false);
      onClose();
    }, 1500);
  };

  if (!platform) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`Connect ${platform.platform}`}>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="bg-slate-50 p-4 rounded-lg border border-slate-100 flex items-center space-x-3 mb-4">
          <div className={`p-2 rounded-lg ${platform.bgColor} ${platform.color}`}>
            <platform.icon size={24} />
          </div>
          <div>
            <p className="text-sm text-slate-600">
              You are connecting <strong>{platform.platform}</strong> to Adnaki.
              Please enter your credentials to authorize this connection.
            </p>
          </div>
        </div>

        <Input
          label="Username or Email"
          placeholder={`Enter your ${platform.platform} username`}
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />

        <Input
          label="Password"
          type="password"
          placeholder="Enter your password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <p className="text-xs text-slate-400 text-center">
          We use secure OAuth 2.0 whenever possible. For this demo, we simulate a direct login.
        </p>

        <div className="flex space-x-3 pt-2">
          <Button type="button" variant="ghost" onClick={onClose} className="flex-1">
            Cancel
          </Button>
          <Button 
            type="submit" 
            className="flex-1" 
            disabled={!username || !password || isLoading}
          >
            {isLoading ? "Connecting..." : "Connect Account"}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default ConnectPlatformModal;
